import React__default from 'react';
import { GenericConfigSection } from './GenericConfigSection.js';

const ConfigSubSection = ({ children, ...props }) => {
  return /* @__PURE__ */ React__default.createElement(GenericConfigSection, { ...props, kind: "sub-section" }, children);
};

export { ConfigSubSection };
//# sourceMappingURL=ConfigSubSection.js.map
